<template>
	<div>
		<div class="columns column1">
			<div class="review-source" :class="item.source" />
		</div>
		<div class="columns column2">
			<span class="review-score">
				<font-awesome-icon
					v-for="(icon, index) in ratingToStars(item.rating)"
					:key="`${item.ID}-${icon}-${index}`"
					:icon="`fa ${icon}`"
					size="1x"
				/>
			</span>
			<p>
				<strong>{{ item.firstName }}</strong>
				<br />
				{{ item.country }}<br />
				{{ $d(new Date(item.date.date.split(' ')[0]), 'short') }}
			</p>
		</div>
		<div class="columns column9">
			<h2>{{ item.header }}</h2>
			<p>{{ item.content }}</p>
		</div>
	</div>
</template>

<script setup>
// const { locale } = useI18n();

defineProps({
	item: { type: Object, default: () => {} },
});

const ratingToStars = (rating) => {
	const fullStars = parseInt(rating / 2, 10);
	const result = Array(fullStars).fill('fa-star');

	if ((rating / 2) % 1 !== 0) {
		result.push('fa-star-half');
	}

	return result;
};
</script>

<style lang="scss" scoped>
.review-item {
	border-bottom: 1px solid #f1f1f1;
	padding: 50px 0;

	img {
		max-width: 100px;
		margin: 15px 0 0;
	}

	.review-score {
		color: #f67c01;
		margin: 15px 0 0;
		display: inline-block;
	}
}

.review-source {
	width: 30px;
	height: 30px;
	background-size: 30px;
	margin: 20px 0 0;

	&.tripadvisor {
		background-image: url('~/assets/images/review-logo-tripadvisor-small.png');
	}

	&.bookingcom {
		background-image: url('~/assets/images/review-logo-bookingcom-small.png');
	}

	&.zoover {
		background-image: url('~/assets/images/review-logo-zoover-small.png');
	}

	&.expedia {
		background-image: url('~/assets/images/review-logo-expedia-small.png');
	}

	&.google {
		background-image: url('~/assets/images/review-logo-google-small.png');
	}
}

@media (max-width: 960px) {
	.column1,
	.column2 {
		width: 100%;
	}
}
</style>
